<script>
  'use strict'

  import { _tilesCollections, _currentMode, _selectedTileIdx, _tileMap, tileX, tileY } from "../store/store";
  import TileImport from './TileImport.svelte';
  import Popup from "./Popup.svelte";
  import TileCollectionManager from "./TileCollectionManager.svelte";

  let tiles = [];
  let currentMode = null;
  let selectedTileIdx = null;

  // -------------------------------------------------
  _tilesCollections.subscribe(data => {
    tiles = data;
    updateOnTilesChange();
  });

  _currentMode.subscribe(data => {
    currentMode = data;
  })

  _selectedTileIdx.subscribe(data => {
    selectedTileIdx = data;
  })

  // -------------------------------------------------
  function updateOnTilesChange() {
    document.documentElement.style.setProperty('--nb-tiles', tiles.length);
  }

  function setSelectedTileIdx(value) {
    let idxFounded = tiles.findIndex(elm => elm === value);
    if (idxFounded >= 0) {
      _selectedTileIdx.set(idxFounded);
    }
  }

  function coverMap() {
    let currentMap = $_tileMap;

    for (let y = 0; y < currentMap.length; y++) {
      for (let x = 0; x < currentMap[y].length; x++) {
        if (currentMap[y][x] === '_') {
          currentMap[y][x] = selectedTileIdx;
        }
      }
    }

    _tileMap.set(currentMap);
  }
</script>

<div class="tiles-options">
  <div class="paint-type">
    <img src="/images/mode/{currentMode}.png" alt="drawing mode" title="To change mode press key [b]: brush, [p]: picker" class="picker-mode-icon">
  </div>
  <div class="current-tile" title="dbl click to cover empty area" on:dblclick="{coverMap}">
    <img src="{ tiles[selectedTileIdx] }" alt="Selected tile" class="selected-tile">
  </div>

  {#if tiles.length === 0}
    <div class="tile-selector">
      <TileImport></TileImport>
    </div>
  {:else}
    <div class="tile-selector">
      {#each tiles as tile, idx}
        <img
          src="{ tile }"
          alt="grass"
          class="tile-to-select {selectedTileIdx === idx ? 'selected-tile' : 'not-selected-tile' }"
          style="aspect-ratio: 1/1"
          on:click={ () => setSelectedTileIdx(tile) }
        >
      {/each}
    </div>
  {/if }

  <div>
    <Popup btnName={'MANAGE TILES'} sectionTitle={'MANAGE TILES'}>
      <TileCollectionManager></TileCollectionManager>
    </Popup>
  </div>
</div>

<style>
.tiles-options {
  padding: 6px;
  display: grid;
  grid-template-columns: var(--tile-size) var(--tile-size) auto 140px;
  gap: 12px;
  align-items: center;
}

.tile-selector {
  display: grid;
  grid-template-columns: repeat(var(--nb-tiles), var(--tile-size));
  justify-content: center;
  gap: 6px;
  min-width: 50%;
  box-sizing: border-box;
  overflow-x: auto;
}

.picker-mode-icon {
  background: white;
  border-radius: 6px;
  width: 100%;
  max-width: 32px;
}

.paint-type {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.current-tile {
  box-sizing: border-box;
}
.tile-to-select:hover {
  cursor: pointer;
  opacity: 0.8;
  box-sizing: border-box;
  border: 2px dotted var(--hightlight-color);
}

.selected-tile {
  border: 2px solid var(--hightlight-color);
  width: var(--tile-size);
  box-sizing: border-box;
  aspect-ratio: 1 / 1;
}

.not-selected-tile {
  opacity: 0.6;
  width: var(--tile-size);
}
</style>